import React from 'react'
import { Container } from './styles'
import Slider from 'react-slick'

type Props = {
  children: any;
}

const settings = {
  dots: true,
  arrows: false,
  infinite: false,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1
}

const SliderDrag = ({ children }: Props) => {
  return (
    <Container>
      <Slider {...settings} className="slider">
        {children}
      </Slider>
    </Container>
  )
}

export default SliderDrag
